var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeselectedCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138.2 138.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#17365f;stroke-linecap:round;stroke-miterlimit:10;stroke-width:14px;}.cls-2{fill:#17365f;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.1,13c30.93,0,56.1,25.17,56.1,56.1s-25.17,56.1-56.1,56.1S13,100.04,13,69.1,38.17,13,69.1,13M69.1,0C30.94,0,0,30.94,0,69.1s30.94,69.1,69.1,69.1,69.1-30.94,69.1-69.1S107.26,0,69.1,0h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.89,
    y1: 72.41,
    x2: 62.14,
    y2: 95.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.2,
    y1: 42.37,
    x2: 63.18,
    y2: 95.14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeselectedCheck);
export default __webpack_public_path__ + "static/media/deselected-check.06173f8c7d2af958f36be4f67cc0ec1f.svg";
export { ForwardRef as ReactComponent };